import { useQuery } from "@tanstack/react-query";
import api from "../../../services/api";
import { useAuth } from "../../../contexts/AuthContext";

export const REMINDER_STATUS_QUERY_KEY = ["reminderStatus"];

/**
 * Reminder is "set up" when the user has connected Telegram (telegramChatId).
 */
export const useReminderSetupStatus = (enabled = true) => {
  const { isAuthenticated } = useAuth();

  const query = useQuery({
    queryKey: REMINDER_STATUS_QUERY_KEY,
    queryFn: async () => {
      try {
        const response = await api.get("/reminders");
        return response.data?.reminder ?? null;
      } catch (error) {
        if (error?.response?.status === 404) return null;
        throw error;
      }
    },
    enabled: Boolean(enabled && isAuthenticated),
    staleTime: 30 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const isReminderSetup = Boolean(query.data?.telegramChatId);

  const showReminderSetupBanner =
    Boolean(enabled) &&
    (!isAuthenticated || (query.isSuccess && !isReminderSetup));

  return {
    reminder: query.data ?? null,
    isReminderSetup,
    needsReminderSetup: showReminderSetupBanner,
    showReminderSetupBanner,
    isLoading: isAuthenticated && query.isLoading,
  };
};
